var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPaymentInfo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5309_47990)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0814 17.3033V26.4555H12.9109C10.5021 26.4555 8.54416 28.4134 8.54416 30.8222V45.6485C8.54416 48.0573 10.5021 50.0152 12.9109 50.0152H38.1967C40.6055 50.0152 42.5635 48.0573 42.5635 45.6485V44.7854H56.9518V17.3033H15.0814ZM12.9109 29.0897H38.1967C39.15 29.0897 39.9293 29.869 39.9293 30.8222V42.1448H11.1784V30.8222C11.1784 29.869 11.9577 29.0897 12.9109 29.0897ZM39.9293 45.6485C39.9293 46.6017 39.15 47.381 38.1967 47.381H12.9109C11.9577 47.381 11.1784 46.6017 11.1784 45.6485V44.7854H39.9293V45.6485ZM54.3176 42.1512H42.5699V30.8286C42.5699 28.4198 40.612 26.4619 38.2032 26.4619H17.722V19.944H54.3176V42.1577V42.1512Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.0101 31.6981H13.7804V39.5428H19.0101V31.6981Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7091 22.5331H20.324V25.1673H51.7091V22.5331Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7092 36.9214H45.1719V39.5556H51.7092V36.9214Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3273 36.9214H21.6315V39.5556H37.3273V36.9214Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7092 27.3314H45.1719V29.9656H51.7092V27.3314Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7092 32.1232H45.1719V34.7574H51.7092V32.1232Z",
    fill: "#001D3D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7059 0.312988C15.9315 0.312988 0.705933 15.5386 0.705933 34.313C0.705933 53.0874 15.9315 68.313 34.7059 68.313C53.4803 68.313 68.7059 53.0874 68.7059 34.313C68.7059 15.5386 53.4868 0.312988 34.7059 0.312988ZM34.7059 65.6981C17.3742 65.6981 3.32082 51.6447 3.32082 34.313C3.32082 16.9813 17.3742 2.92788 34.7059 2.92788C52.0376 2.92788 66.091 16.9813 66.091 34.313C66.091 51.6447 52.0376 65.6981 34.7059 65.6981Z",
    fill: "#001D3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5309_47990"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white",
    transform: "translate(0.705933 0.312988)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentInfo);
export default __webpack_public_path__ + "static/media/payment_info.f0cf53ed92daa0e1438559b6a8e70148.svg";
export { ForwardRef as ReactComponent };